"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.splitsSyncTaskFactory = void 0;
var syncTask_1 = require("../../syncTask");
var splitChangesFetcher_1 = require("../fetchers/splitChangesFetcher");
var splitChangesUpdater_1 = require("../updaters/splitChangesUpdater");
/**
 * Creates a sync task that periodically executes a `splitChangesUpdater` task
 */
function splitsSyncTaskFactory(fetchSplitChanges, storage, readiness, settings, isClientSide) {
    return (0, syncTask_1.syncTaskFactory)(settings.log, (0, splitChangesUpdater_1.splitChangesUpdaterFactory)(settings.log, (0, splitChangesFetcher_1.splitChangesFetcherFactory)(fetchSplitChanges), storage.splits, storage.segments, settings.sync.__splitFiltersValidation, readiness.splits, settings.startup.requestTimeoutBeforeReady, settings.startup.retriesOnFailureBeforeReady, isClientSide), settings.scheduler.featuresRefreshRate, 'splitChangesUpdater');
}
exports.splitsSyncTaskFactory = splitsSyncTaskFactory;
